import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LoginForm } from '@paysense-india-services/auth-vista'
import { payufinSessionStorage } from '@paysense-india-services/payufin-jsutils'

import { PORTAL_HEADER_KEY, SEND_OTP_API } from '@/constants/api'
import { ROUTES } from '@/constants/routes'
import { SESSION_STORAGE_KEYS } from '@/constants/sessionStorageKeys'

import { getErrorMessage } from '@/lib/apiUtils'

import Header from '@/components/Header'
import Logo from '@/components/Logo'

function LoginPage() {
  const [data, setData] = useState({})
  const [error, setError] = useState({})
  const navigate = useNavigate()

  const mapRequestBody = mobile => {
    payufinSessionStorage.setToSession(SESSION_STORAGE_KEYS.USER_MOBILE, mobile)
    return {
      data: {
        phone: mobile
      },
      headers: {
        accept: 'application/json',
        ...PORTAL_HEADER_KEY
      }
    }
  }

  const handleGetOTPSuccess = res => {
    setData({ ...res })
    navigate(ROUTES.OTP)
  }

  const handleGetOTPError = err => {
    setError({ message: getErrorMessage(err) })
  }

  return (
    <>
      <Header hideOnDesktop leftComponent={Logo} />
      <div className='ew-d-flex ew-flex-1 ew-align-items-center ew-justify-content-center ew-mt-md-24'>
        <LoginForm
          api={SEND_OTP_API}
          config={{
            title: 'Welcome PayU Finance',
            subTitle: 'Please enter your phone number to proceed'
          }}
          data={data}
          error={error}
          getRequestBody={mapRequestBody}
          isDisabled={error?.message}
          onChange={() => setError({})}
          onError={handleGetOTPError}
          onSuccess={handleGetOTPSuccess}
        />
      </div>
    </>
  )
}

export default LoginPage
